import {clearClaims, fetchClaims} from './UserActions'
import type {AppDispatch} from '../store'
import {persistentStorage} from '../utils/persistence-storage'

/**
 * Authentication operation related action types.
 */
export enum AuthActionType {
  AUTH_START = 'AUTH_START',
  AUTH_SUCCESS = 'AUTH_SUCCESS',
  AUTH_FAILURE = 'AUTH_FAILURE',
  AUTH_CLEAR = 'AUTH_SESSION_CLEAR',
}

interface AuthenticationStartedAction {
  type: AuthActionType.AUTH_START
}

interface AuthenticationSuccessAction {
  type: AuthActionType.AUTH_SUCCESS
  payload: {
    token: string
  }
}

interface AuthenticationFailureAction {
  type: AuthActionType.AUTH_FAILURE
  payload: {
    error: string
  }
}

interface ClearAuthenticationSessionAction {
  type: AuthActionType.AUTH_CLEAR
}

export type AuthAction =
  | AuthenticationStartedAction
  | AuthenticationSuccessAction
  | AuthenticationFailureAction
  | ClearAuthenticationSessionAction

export function loginFailed(message: string) {
  return async (dispatch: AppDispatch) => {
    persistentStorage.previousLoginError.setMessage(message)
    dispatch({
      type: AuthActionType.AUTH_FAILURE,
      payload: {
        error: message
      }
    })
  }
}

export function loggedIn(payload: { token: string }): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    persistentStorage.authToken.set(payload.token)
    persistentStorage.previousLoginError.clear()
    dispatch<AuthAction>({
      type: AuthActionType.AUTH_SUCCESS,
      payload
    })
    // Note: fetchClaims() action will test the token with backend call and force logout if token has expired/is invalid
    await dispatch(fetchClaims())
  }
}

export function logout() {
  console.info('logging out')
  return async (dispatch: AppDispatch) => {
    persistentStorage.authToken.clear()

    dispatch(clearClaims())
    dispatch<AuthAction>({
      type: AuthActionType.AUTH_CLEAR
    })
  }
}
